import React from 'react';

import SubHeading from '../SubHeading/SubHeading';
import './Reservation.css';

const Reservation = () => (
  <div className="app__newsletter">
    <div className="app__newsletter-heading">
      <SubHeading title="Reserve Your Table" />
      <h1 className="headtext__cormorant">Secure Your Reservation</h1>
      <p className="p__opensans">Don’t miss out—reserve your spot today!</p>
    </div>
    <div className="app__newsletter-input flex__center">
      <button type="button" className="custom__button">Reserve Now</button>
    </div>
  </div>
);

export default Reservation;